import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Toaster } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@aarogyaclinic.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("aarogya_admin_token", data.access_token);
      localStorage.setItem("aarogya_admin_email", data.admin_email);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(errMsg(err, "Invalid credentials"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center hero-gradient p-6">
      <Toaster richColors position="top-center" />
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl border border-slate-200/60 p-8 bg-white aarogya-shadow" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-2xl grid place-items-center text-white"
               style={{ background: "linear-gradient(135deg,#3F2D86,#0A6EBD)" }}>
            <Lock className="h-5 w-5" />
          </div>
          <div>
            <div className="font-serif text-2xl text-slate-900">Admin Login</div>
            <div className="text-xs text-slate-500">Aarogya Clinic Dashboard</div>
          </div>
        </div>

        <div className="mt-6 space-y-4">
          <div>
            <div className="text-xs font-semibold text-slate-600 mb-1.5">Email</div>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                   className="w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#3F2D86]"
                   data-testid="admin-email-input" />
          </div>
          <div>
            <div className="text-xs font-semibold text-slate-600 mb-1.5">Password</div>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
                   className="w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#3F2D86]"
                   data-testid="admin-password-input" />
          </div>
          <button disabled={loading} className="w-full rounded-full py-3 text-white font-semibold disabled:opacity-70"
                  style={{ background: "#3F2D86" }} data-testid="admin-login-btn">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
